import { UnitType } from "@sinch/core/entities/serverEnums";
import { useTranslation } from "react-i18next";
import { useEntityProps } from "../utilsHooks";

/**
 * Custom hook to manage condition operators.
 */
export const useUnitType = () => {
  const { t } = useTranslation();

  const operators: Record<UnitType, { label: string; description: string }> = {
    [UnitType.Flat]: { label: t("UnitIntervalType.flat"), description: t("UnitIntervalType.flatDescription") },
    [UnitType.Worked]: { label: t("UnitIntervalType.worked"), description: t("UnitIntervalType.workedDescription") },
    [UnitType.Planned]: { label: t("UnitIntervalType.planned"), description: t("UnitIntervalType.plannedDescription") },
    [UnitType.Overtime]: {
      label: t("UnitIntervalType.overtime"),
      description: t("UnitIntervalType.overtimeDescription"),
    },
    [UnitType.Custom]: { label: t("UnitIntervalType.custom"), description: t("UnitIntervalType.customDescription") },
  };
  const getProp = useEntityProps(operators);

  const geUnitTypeLabel = getProp<string>("label");
  const getUnitTypeDescription = getProp<string>("description");

  const getOptionsList = () =>
    Object.entries(operators).map(([key, value]) => ({
      value: key,
      label: value.label,
      description: value.description,
    }));

  return { geUnitTypeLabel, getUnitTypeDescription, getOptionsList };
};
